export enum StatusAtendimentoSala {

  EM_ESPERA = 'EM_ESPERA',

  EM_ATENDIMENTO = 'EM_ATENDIMENTO',

  REALIZADO = 'REALIZADO',

  CANCELADO = 'CANCELADO'

}